module.exports = __webpack_public_path__ + "5.0.2/img/pic_7.55128121.png";